import { Observable, of } from 'rxjs';
import { delay, distinctUntilChanged, switchMap } from 'rxjs/operators';

/** Keeps a loading boolean true for at least `ms` ms after it goes false, avoiding jitter. */
export function nicerLoading(loading$: Observable<boolean>, ms = 350): Observable<boolean> {
  return loading$.pipe(
    switchMap((loading) => loading ? of(true) : of(false).pipe(delay(ms))),
    distinctUntilChanged(),
  );
}

/**
 * check if the window view port reach out the max width query
 * @return {boolean}
 */
export function isMobile(): boolean {
  return window.matchMedia('(max-width:600px)').matches;
}

/**
 * check if the window view port reach out the max width query
 * @return {boolean}
 */
export function isWideScreen(): boolean {
  return window.matchMedia('(max-width:1440px)').matches;
}
